import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserRole } from 'src/app/models/users/user-role';
import { UserViewModel } from 'src/app/models/users/user-view.model';
import { UserService } from 'src/app/modules/core/services/user.service';

@Component({
  selector: 'app-user-details',
  templateUrl: './user-details.component.html',
  styleUrls: ['./user-details.component.css']
})
export class UserDetailsComponent implements OnInit {

  user: UserViewModel;
  customersName: string[];
  copyCustomerName: string;
  userRoles = [
    { value: UserRole.Admin, description: "Admin" },
    { value: UserRole.User, description: "User" },
    { value: UserRole.Documenter, description: "Documenter" }];

  constructor(private route: ActivatedRoute,
    private router: Router,
    private userrService: UserService) { }

  ngOnInit() {
    this.route.data.subscribe(value => {
      this.user = value.user || UserViewModel.make(null);
    });
  }

  async save() {
    if (!this.user.firstName || !this.user.lastName || !this.user.username || (!this.user.id && !this.user.password))
      return;

    this.execute();
  }

  async execute() {
    this.user.userRole = Number.parseInt(this.user.userRole.toString());
    if (!this.user.id)
      this.user.id = await this.userrService.create(this.user);
    else
      await this.userrService.update(this.user);

    this.router.navigate(['/admin/users']);
  }

}
